import type { Json } from '@/supabase/types';

import { computed, ref } from 'vue';

import { supabase } from '@/src/supabase';

export interface OrgRow {
  id: string;
  card: { [key: string]: Json | undefined };
}

export function orgChipLabel(item: OrgRow | undefined): string {
  if (!item) return '';
  return (item.card?.fn ?? '') as string;
}

export function useOrgs() {
  const orgs = ref<OrgRow[]>([]);

  async function loadOrgs() {
    const { data, error } = await supabase
      .from('org')
      .select(`person ( id, card )`);

    if (error) throw error;
    orgs.value = data
      .filter(o => o.person)
      .map(o => ({
        id: o.person.id,
        card: o.person.card,
      })) as OrgRow[];
  }

  const orgAutocompleteItems = computed(() =>
    orgs.value.map(role => ({
      title: orgChipLabel(role),
      value: role.id,
    })),
  );

  return {
    orgs,
    loadOrgs,
    orgAutocompleteItems,
  };
}
